function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M116.6,64c0,12.9-4.7,24.7-12.4,33.8l8.8,7.4C122.3,94.1,128,79.7,128,64s-5.7-30.1-15.1-41.2l-8.8,7.4 C111.9,39.3,116.6,51.1,116.6,64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.4,64c0-12.9,4.7-24.7,12.4-33.8l-8.8-7.4C5.7,33.9,0,48.3,0,64s5.7,30.1,15.1,41.2l8.8-7.4 C16.1,88.7,11.4,76.9,11.4,64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.7,64c0,7-2.5,13.5-6.7,18.4l8.7,7.3c5.9-7,9.4-15.9,9.4-25.8s-3.5-18.8-9.4-25.8l-8.7,7.3C90.1,50.5,92.7,57,92.7,64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.3,64c0-7,2.5-13.5,6.7-18.4l-8.7-7.3C27.5,45.2,24,54.2,24,64s3.5,18.8,9.4,25.8l8.7-7.3C37.9,77.5,35.3,71,35.3,64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.2,53.7C73.2,50.3,68.9,48,64,48s-9.2,2.3-12.2,5.7C49.5,56.5,48,60.1,48,64c0,3.9,1.5,7.5,3.8,10.3 C54.8,77.7,59.1,80,64,80s9.2-2.3,12.2-5.7C78.5,71.5,80,67.9,80,64C80,60.1,78.5,56.5,76.2,53.7z"
}));
function SvgStreaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: "1em",
    width: "1em",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreaming);
export default __webpack_public_path__ + "static/media/streaming.43238c6409c2f4ec7aef3ecd64f38f2a.svg";
export { ForwardRef as ReactComponent };